import React, { Component } from "react";
import {
  Row,
  Col,
  Tree,
  Button,
  Input,
  Checkbox,
  Pagination,
  Icon,
  Modal,
  message,
  Empty,
  Popconfirm
} from "antd";
import AddToGroup from "../../view/components/numberManageList/AddToGroups";
import NumberManageList from "../components/numberManageList/NumberManageList";
import {
  numberManageList,
  getNumberGroupList,
  getNumberRenameList,
  deleteNumberRenameListId,
  addNumberGroup,
  delNumberGroup,
  addNumberMenuNode,
  // clickUpLoad
} from "../../actions/convergenceMedia";
import { Scrollbars } from "react-custom-scrollbars";
import { HEADER_HEIGHT } from "../../constants";
import "antd/dist/antd.css";
const { Search } = Input;
const { TreeNode } = Tree;

class NumberManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      limit: 10,
      dataList: [],
      listTotal: 0,
      allChoose: false,
      searchValue: null, //搜索
      currentLeftMenuList: [],
      selectKey: "0",
      nodeKey: [],
      visible1: false,
      visible2: false,
      visible3: false,
      rename: "",
      rename2: "",
      renameList: [],
      currentItem: {},
      itemChoose: false,
      fansID: [],
    };
  }
  componentDidMount() {
    this.pageChange();
    this.getGroupLists();
  }
  // 点父选全部子
  allChoose() {
    // 改变子组件选中
    if (this.state.allChoose) {
      this.state.dataList.forEach((item) => {
        item.checked = false;
      });
    } else {
      this.state.dataList.forEach((item) => {
        item.checked = true;
      });
    }
    // 改变父组件自己选中状态
    this.state.allChoose = !this.state.allChoose;
    // 更新
    this.setState({});
  }

  // 点子操作父
  itemClick(item, index) {
    //   点子时把每条数据的状态更新到itemChoose中保存
    let fansID = this.state.fansID;
    if (item.checked) {
      //说明当前已选中 取消选中
      fansID.filter((fansItem) => fansItem === item.id);
    } else {
      //说明当前未选中 选中
      fansID.push(item.id);
    }
    this.setState({
      itemChoose: item,
      fansID,
    });
    // this.state.itemChoose = item.checked;
    // 把每条数据的显示状态给每条数据对应下标的显示状态
    this.state.dataList[index].checked = !item.checked;
    // 获取数据源的长度
    let numMax = this.state.dataList.length;
    // 初始选中的长度
    let num = 0;
    // 遍历数据源判断
    this.state.dataList.forEach((item) => {
      // 如果一个子未选中，则父不选中
      if (item.checked === false) {
        this.state.allChoose = false;
      } else {
        // 子长度加1
        num++;
      }
    });
    // 如果子长度等于数据源的长度，则父状态按钮显示
    if (numMax === num) {
      this.state.allChoose = true;
    }
    // 更新
    this.setState({});
  }

  // 获取分组栏目数据
  getGroupLists() {
    getNumberGroupList((res) => {
      let data = JSON.parse(res);
      console.log(data);
      if (data) {
        //   dataList必须是一个数组，否则渲染时，判断.length为undefind，渲染不出
        let dataList = [
          {
            name: "全部",
            key: "0",
            id: 0,
            sons: data,
          },
        ];
        this.setState({
          currentLeftMenuList: dataList,
        });
        console.log(this.state.currentLeftMenuList)
      }
    });
  }

  // 获取重命名更新数据
  getrenameLists() {
    let params = {
      name: this.state.rename,
    };
    if (this.state.currentItem.id) {
      params.id = this.state.currentItem.id;
    }
    getNumberRenameList(params, (res) => {
      if (res) {
        message.info("修改成功");
        this.getGroupLists();
      } else {
        message.error("修改失败");
      }
    });
  }

  // 渲染父节点
  renderTreeNodes = data => {
    console.log("@", data);
    return (
      data.map(item => {
        if (item.sons) {
          return (
            <TreeNode title={<span style={{ fontSize: 18 }}>
              {item.name}
              <span style={{ width: 50 }}>
                <Icon type="plus" style={{ marginLeft: 20, marginRight: 10 }}
                  onClick={
                    this.showModal1
                  } />
              </span>
            </span>}
              key={item.id} dataRef={item}>
            </TreeNode>
          )
        } else {
          return (
            <TreeNode title={<span style={{ fontSize: 18 }}>
              {item.name}
              {item.name === '全部' && item.id === 0 ? null : <span><Icon
                type="edit" style={{ marginLeft: 10, marginRight: 10 }} onClick={() => {
                  this.showModal2(item)
                }} /></span>}

              {item.name === '全部' && item.id === 0 ? null :
                <Popconfirm title={"请确认是否删除(" + item.name + ")节点?"}
                  onConfirm={() => {
                    this.showModal3(item)
                  }}
                  onCancel={() => {
                  }}
                  okText="确认"
                  cancelText="取消"><span><Icon
                    type="close" style={{ marginLeft: 10, marginRight: 10 }} onClick={() => {
                    }} /></span></Popconfirm>}
            </span>}
              key={item.id} dataRef={item}>
              {this.renderTreeNodes(item.sons)}
            </TreeNode>
          );
        }
      })
    );
  }
  // 全部模块
  showModal1 = (item) => {
    this.setState({
      visible1: true,
      rename2: item.name,
    });
  };
  //保存节点
  addNode() {
    let params = {
      name: this.state.rename2,
    };
    addNumberMenuNode(params, (res) => {
      if (res === "-1") {
        message.error("新增点code重复");
      } else {
        if (res === 0) {
          message.info("新增菜单节点成功");
          this.getGroupLists();
        } else {
          message.error("新增菜单节点失败");
        }
      }
    });
  }
  handleOk1 = (e) => {
    this.addNode();
    this.setState({
      visible1: false,
    });
  };

  handleCancel1 = (e) => {
    this.setState({
      visible1: false,
    });
  };
  // 重命名
  showModal2(item) {
    this.state.currentItem = item;
    this.setState({
      visible2: true,
      rename: item.name,
    });
  }

  handleOk2 = () => {
    this.getrenameLists();
    this.setState({
      visible2: false,
    });
  };

  handleCancel2 = (e) => {
    this.setState({
      visible2: false,
    });
  };
  // 删除
  showModal3(item) {
    this.state.currentItem = item.id;
    this.setState({
      visible3: true,
    });
  }

  handleOk3 = (e) => {
    this.deleteRenameListId(this.state.currentItem);
    this.pageChange();
    this.setState({
      visible3: false,
    });
  };

  handleCancel3 = (e) => {
    this.setState({
      visible3: false,
    });
  };
  // 获取删除id
  deleteRenameListId(renameID) {
    let params = {
      groupids: renameID,
    };
    deleteNumberRenameListId(params, (res) => {
      let data = JSON.parse(res);
      if (data.data) {
        message.success("删除成功");
        // 直接更新
        this.getGroupLists();
      } else {
        message.error("删除失败");
      }
    });
  }
  render() {
    let newSecondSelectColor =
      this.props.config && this.props.config.getValueByKey
        ? this.props.config.getValueByKey("newSecondSelectColor", "#1E9FFF")
        : "#1E9FFF";
    let height = window.innerHeight - HEADER_HEIGHT; //上部分70//
    return (
      <div>
        <div style={{ position: "relative" }}>
          <div
            style={{
              width: "100%",
              height: "42px",
              lineHeight: "42px",
              padding: "0 15px",
              borderBottom: "1px solid #f6f6f6",
              color: "#333",
              borderRadius: "2px 2px 0 0",
              fontSize: "14px",
              margin: "15px 0px 0px 0px",
              backgroundColor: "#fff",
            }}
          >
            融媒号管理
          </div>
          <div
            style={{
              backgroundColor: "#fff",
            }}
          >
            <Row>
              <Col span={5}>
                <div
                  style={{
                    width: "256px",
                    padding: "20px 0px 20px 55px",
                  }}
                >
                  {/* 左侧菜单 */}
                  {this.state.currentLeftMenuList.length > 0 ? (
                    <Tree
                      defaultExpandAll
                      onSelect={this.onSelect}
                      selectedKeys={this.state.nodeKey}
                    >
                      {this.renderTreeNodes(this.state.currentLeftMenuList)}
                    </Tree>
                  ) : null}
                </div>
              </Col>
              {/* 全部模块 */}
              <Modal
                title="分组信息"
                visible={this.state.visible1}
                onOk={this.handleOk1}
                onCancel={this.handleCancel1}
                centered
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div>分组名称</div>
                  <div style={{ marginLeft: "20px" }}>
                    <Input
                      value={this.state.rename2}
                      onChange={(e) => this.onChange3(e)}
                      placeholder="请输入分组名称"
                    />
                  </div>
                </div>
              </Modal>
              {/* 重命名模块 */}
              <Modal
                title="分组信息"
                visible={this.state.visible2}
                onOk={this.handleOk2}
                onCancel={this.handleCancel2}
                centered
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div>分组名称</div>
                  <div style={{ marginLeft: "20px" }}>
                    <Input
                      value={this.state.rename}
                      onChange={(e) => this.onChange2(e)}
                    />
                  </div>
                </div>
              </Modal>
              {/* 删除模块 */}
              <Modal
                title="分组信息"
                visible={this.state.visible3}
                onOk={this.handleOk3}
                onCancel={this.handleCancel3}
                centered
                width="300px"
              >
                确定删除此分组？
              </Modal>
              <Col
                span={19}
                style={{
                  paddingLeft: "20px",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "27px",
                    paddingBottom: "10px",
                    borderBottom: "1px solid #f6f6f6",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <div>
                      <Button type="primary" onClick={this.addToGroup}>
                        添加至分组
                      </Button>
                    </div>
                    <AddToGroup
                      currentLeftMenuList={this.state.currentLeftMenuList}
                      // groupID={this.state.groupID}
                      //   fansID={this.state.fansID.id}
                      fansCount={this.state.fansCount}
                      getAddGroups={(value) => this.getAddGroups(value)}
                      ref="addToGroup"
                    />
                    <div style={{ marginLeft: "30px" }}>
                      <Button type="danger" onClick={this.delToGroup}>
                        从分组中删除
                      </Button>
                    </div>
                  </div>
                  <div style={{ marginRight: "10px" }}>
                    <Search
                      placeholder="请输入搜索内容"
                      onSearch={(value) => this.onSearch(value)}
                      value={this.state.searchValue}
                      onChange={(e) => {
                        this.setState({
                          searchValue: e.target.value,
                        });
                      }}
                      style={{ width: 200 }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <table
                    style={{
                      border: "1px solid #666",
                      marginTop: "10px",
                      textAlign: "center",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          border: "1px solid #e6e6e6",
                          backgroundColor: "#f6f6f6",
                          height: "15px",
                          lineHeight: "15px",
                        }}
                      >
                        <th
                          style={{
                            width: "48px",
                            borderRight: "1px solid #e6e6e6",
                          }}
                        >
                          <Checkbox
                            style={{ padding: "10px" }}
                            onClick={() => {
                              this.allChoose();
                            }}
                            checked={this.state.allChoose}
                          />
                        </th>
                        <th style={{ width: "360px" }}>头像</th>
                        <th style={{ width: "360px" }}>名称</th>
                        <th style={{ width: "360px" }}>类型</th>
                        <th style={{ width: "360px" }}>所在单位</th>
                      </tr>
                    </thead>
                  </table>
                  {/* 处理滚动条的方法以及自适应 */}
                  <div style={{ height: height - 180, background: "white", width: "100%" }}>
                    <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                      {
                        this.state.dataList.length === 0 ? <Empty style={{ position: "absolute", top: "45%", left: "45%" }} /> : null
                      }
                      {/* 循环组件 */}
                      {this.state.dataList &&
                        this.state.dataList.map((item, index) => {
                          return (
                            <NumberManageList
                              ref="set"
                              newSecondSelectColor={newSecondSelectColor}
                              key={index}
                              {...item}
                              avatar={item.headImageUrl}
                              name={item.name}
                              type={item.type}
                              deptName={item.deptName}
                              checked={item.checked} //拿到每条数据的checked属性
                              ItemClick={() => {
                                this.itemClick(item, index); //传一个操作每条数据的方法
                              }}
                            />
                          );
                        })}
                    </Scrollbars>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "10px",
                      position: "absolute",
                      marginBottom: "10px",
                      marginRight: "10px"
                    }}
                  >
                    <Pagination
                      hideOnSinglePage={true}
                      showQuickJumper
                      current={this.state.pageNo}
                      pageSize={this.state.limit}
                      total={this.state.listTotal}
                      showTotal={(total) => `共 ${total} 条`}
                      showSizeChanger
                      onChange={(page, pageSize) =>
                        this.onChange(page, pageSize)
                      } //页码改变时回调
                      onShowSizeChange={(page, pageSize) => {
                        this.onChange(page, pageSize); //每页条数改变回调
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
  // 获取加入数据
  getAddGroups(value) {
    let params = {
      groupIds: value,
      fansIds: this.state.fansID,
    };
    addNumberGroup(params, (res) => {
      if (res.data === "添加成功") {
        message.info("加入成功");
        this.pageChange();
        this.getGroupLists();
      } else {
        message.error("加入失败");
      }
    });
  }
  // 从分组中删除数据
  getDeleteGroups(value) {
    let params = {
      groupIds: value,
      fansIds: this.state.fansID,
    };
    delNumberGroup(params, (res) => {
      if (res === 1) {
        message.info("删除成功");
        this.pageChange();
        this.getGroupLists();
      } else {
        message.error("删除失败");
      }
    });
  }

  // 页面改变时回调
  onChange(page, pageSize) {
    // 放入变量中
    this.state.pageNo = page;
    this.state.limit = pageSize;
    // 每次改变页码时
    this.pageChange();
  }
  pageChange() {
    // //先取出变量
    let params = {
      pageNo: this.state.pageNo,
      limit: this.state.limit,
    };
    // 需要判断不等于0时，查全部不需要传id
    if (this.state.nodeKey !== 0) {
      params.fansGroupId = this.state.nodeKey;
    }
    if (this.state.searchValue) {
      params.query = this.state.searchValue;
    }
    numberManageList(params, (res) => {
      let data = res;
      let dataList = [];
      let listTotal = 0; //列表总数
      if (data && data.data) {
        dataList = data.data;
        // 遍历数据源给每条数据添加checked属性
        dataList.forEach((item) => {
          item.checked = false;
        });
        listTotal = data.count;
      }
      this.setState({
        dataList: dataList,
        listTotal: listTotal,
      });
    });
    // 分页时清空全选按钮
    this.setState({
      allChoose: false,
    });
  }
  //搜索
  onSearch(value) {
    this.state.searchValue = value;
    this.state.pageNo = 1;
    this.state.limit = 10;
    this.pageChange();
  }
  //   点击树节点
  onSelect = (selectedKeys) => {
    this.state.nodeKey = selectedKeys;
    this.state.pageNo = 1;
    this.state.limit = 10;
    this.setState({});
    this.pageChange();
  };
  //   重命名
  onChange2(e) {
    this.setState({
      rename: e.target.value,
    });
  }
  //   添加
  onChange3(e) {
    this.setState({
      rename2: e.target.value,
    });
  }
  //   添加至分组
  addToGroup = () => {
    if (!this.state.allChoose) {
      //未全选
      let flag = false;
      this.state.dataList &&
        this.state.dataList.length > 0 &&
        this.state.dataList.forEach((item) => {
          if (item.checked) {
            flag = true;
          }
        });
      if (!flag) {
        message.error("没有选中任何粉丝");
        return;
      }
    }
    this.refs.addToGroup.showModal();
  };
  //   删除分组
  delToGroup = () => {
    if (this.state.nodeKey.length === 0) {
      message.error("没有选中任何粉丝分组");
      return;
    }
    if (!this.state.allChoose) {
      //未全选
      let flag = false;
      this.state.dataList &&
        this.state.dataList.length > 0 &&
        this.state.dataList.forEach((item) => {
          if (item.checked) {
            flag = true;
          }
        });
      if (!flag) {
        message.error("没有选中任何粉丝");
        return;
      }
    }
    this.getDeleteGroups(this.state.nodeKey);
  };
}

export default NumberManage;
